import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=eb93c6d6&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=eb93c6d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb93c6d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb93c6d6')) {
      api.createRecord('eb93c6d6', component.options)
    } else {
      api.reload('eb93c6d6', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=eb93c6d6&scoped=true&", function () {
      api.rerender('eb93c6d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O4573992EJmS/JS/comp/CookieBox.vue"
export default component.exports